module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['BaseRadio', _vm.className]
  }, [_vm._m(0), _vm._v(" "), _vm._l((_vm.items), function(item, index) {
    return _c('div', {
      key: item.id,
      staticClass: "BaseRadio__item"
    }, [_c('input', {
      attrs: {
        "type": "radio",
        "id": 'radio' + _vm.fieldName + '_' + index,
        "name": 'radio' + _vm.fieldName
      },
      domProps: {
        "value": item.id,
        "checked": _vm.value == item.id
      },
      on: {
        "change": function($event) {
          _vm.change($event)
        }
      }
    }), _vm._v(" "), _vm._o(_c('label', {
      staticClass: "BaseRadio__item-label",
      attrs: {
        "for": 'radio' + _vm.fieldName + '_' + index
      }
    }, [_vm._v(_vm._s(_vm.translate(item.name)))]), 0, item.id)])
  }), _vm._v(" "), _c('BaseErrors', {
    attrs: {
      "errors": _vm.errors
    }
  })], 2)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "BaseRadio__label"
  }, [_vm._v(_vm._s(_vm.translate(_vm.label)))])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-696245d2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BaseRadio.vue
// module id = 547
// module chunks = 1